export default "https://cdn-gra.amplement.io/statics/images/placeholder/placeholderContact@2x.png";